(() => {
  const menus = document.querySelectorAll('[data-pikuchi-mega-menu]');

  menus.forEach((menu) => {
    const items = menu.querySelectorAll('[data-menu-item]');
    const drawer = menu.querySelector('[data-mobile-drawer]');
    const openButton = menu.querySelector('[data-mobile-toggle]');
    const closeButton = menu.querySelector('[data-mobile-close]');
    let closeTimer = null;

    const closeAll = () => {
      items.forEach((item) => {
        item.classList.remove('is-open');
        const link = item.querySelector('.pikuchi-mega__link[aria-expanded]');
        if (link) link.setAttribute('aria-expanded', 'false');
      });
    };

    const openItem = (item) => {
      window.clearTimeout(closeTimer);
      closeAll();
      item.classList.add('is-open');
      const link = item.querySelector('.pikuchi-mega__link[aria-expanded]');
      if (link) link.setAttribute('aria-expanded', 'true');
    };

    const scheduleClose = () => {
      window.clearTimeout(closeTimer);
      closeTimer = window.setTimeout(closeAll, 90);
    };

    items.forEach((item) => {
      if (!item.querySelector('[data-mega-panel]')) return;
      item.addEventListener('mouseenter', () => openItem(item));
      item.addEventListener('mouseleave', scheduleClose);
      item.addEventListener('focusin', () => openItem(item));
      item.addEventListener('focusout', (event) => {
        if (!item.contains(event.relatedTarget)) scheduleClose();
      });
    });

    const openDrawer = () => {
      if (!drawer || !openButton) return;
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      openButton.setAttribute('aria-expanded', 'true');
      document.body.classList.add('pikuchi-mega-drawer-open');
    };

    const closeDrawer = () => {
      if (!drawer || !openButton) return;
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      openButton.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('pikuchi-mega-drawer-open');
    };

    if (openButton) openButton.addEventListener('click', openDrawer);
    if (closeButton) closeButton.addEventListener('click', closeDrawer);
    if (drawer) {
      drawer.addEventListener('click', (event) => {
        if (event.target === drawer) closeDrawer();
      });
    }

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        closeAll();
        closeDrawer();
      }
    });
  });
})();
